window.dataLayer = window.dataLayer || [];

let customerType = "Consumer";

if (window.customerTags.includes("Wholesaler")) {
  customerType = "Wholesaler";
}
if (window.customerTags.includes("Truckload-buyer")) {
  customerType = "Truckload-buyer";
}

// Push the initial page details to dataLayer
// window.dataLayer.push({
//   event: "user_page_details",
//   page_type: window.pageType,
//   customer_type: customerType,
// });

/**
 * gtm events for collection page filters and price range
 */

// handle filter and price events

//IMPORTANT: filetrs are assgined the onchange inline events
// const selectors = [
// ".facets__label input[type='checkbox']", // desktop filters
// ".mobile-facets__label input[type='checkbox']", // mobile filters
// "#Filter-Price-GTE", // desktop price "from"
// "#Filter-Price-LTE", // desktop price "to"
// "#Mobile-Filter-Price-GTE", // mobile price "from"
// "#Mobile-Filter-Price-LTE", // mobile price "to"
// ];

// Attach event listeners to the selectors
// selectors.forEach((selector) => {
//   document.querySelectorAll(selector).forEach((element) => {
//     element.addEventListener("change", function () {
//       sendCustomFilterEvents(this);
//     });
//   });
// });

function sendCustomFilterEvents(element) {
  const isFilter = element.type === "checkbox";
  const isMobile = element.id.includes("Mobile");

  let dataLayerEvent = {
    event: "apply_filter",
    filter_category: isFilter ? getFilterCategory(element) : "Price",
    filter_value: isFilter ? element.value : getPriceRange(isMobile),
    context: isMobile ? "mobile" : "desktop",
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayerEvent);
}

// Helper function to get filter category
function getFilterCategory(element) {
  const filterCategory = element
    .closest("fieldset")
    ?.querySelector("legend")
    ?.textContent.trim();
  return filterCategory || "Unknown";
}

// Helper function to get price range
function getPriceRange(isMobile) {
  const priceFrom = isMobile
    ? document.querySelector("#Mobile-Filter-Price-GTE")?.value || "0"
    : document.querySelector("#Filter-Price-GTE")?.value || "0";
  const priceTo = isMobile
    ? document.querySelector("#Mobile-Filter-Price-LTE")?.value || "max"
    : document.querySelector("#Filter-Price-LTE")?.value || "max";
  return `${priceFrom}-${priceTo}`;
}

function findPriceRange(price) {
  ranges = ["0-999", "1000-2000", "2000-4999", "5000+"];
  for (let range of ranges) {
    let [min, max] = range.split("-").map(Number);

    if (!max) {
      // Handle "5000+" case, where there's no upper limit
      return price >= min ? range : null;
    }

    if (price >= min && price <= max) {
      return range;
    }
  }
  return null; // Return null if no range found
}
function viemItemsEvent(data) {
  // when user loads a product page
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "view_item",
    ecommerce: {
      items: [
        {
          item_name: data.productData.title, // shopify product name
          item_id: data.productData.id, // shopify product id
          color: "",
          price: Number(data.metafields.price / 100),
          item_price_range: findPriceRange(data.metafields.price / 100), // "0-999", "1000-2000", "2000-4999", "5000+"
          item_coupon: (data.metafields.discount || 0) + "%", // "48%", discount percentage
          item_width: data.metafields.dimensions.width, // item width in inches
          item_depth: data.metafields.dimensions.depth,
          item_brand: "",
          item_on_clearance: "no", // yes/no
          item_category: data.metafields.item_category, // product top category, similar to the available 'Featured Categories', excluding 'Major Appliances'
          item_category2: data.metafields.item_category2, // sub category as in menu (see Figma)
          item_category3: "", // sub category as in menu (see Figma)
          item_category4: "", // sub cateogry as in menu (see Figma)
          item_category5: "", // for stove - induction/electric/gas, for laundry - electric/gas, for cooktops - 'electric/gas', for tv - the resolution -> 4k, LED, UHD etc
          item_category6: "", // for TVs, the TV size in inches, for cooktops - the element numbers
          item_variant: data.metafields.condition, // product condition - new/open box, scratch/dent, like new/refurbished
        },
      ],
    },
  });
}
function atcEvent(data, warrantyData = null) {
  // when user adds a product to the cart
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  const items = [
    {
      item_name: data.productData.title, // shopify product name
      item_id: data.productData.id, // shopify product id
      color: "",
      price: Number(data.metafields.price / 100),
      item_price_range: findPriceRange(data.metafields.price / 100),
      item_coupon: (data.metafields.discount || 0) + "%", // "48%", discount percentage
      item_width: data.metafields.dimensions.width, // item width in inches
      item_depth: data.metafields.dimensions.depth,
      item_brand: "",
      item_on_clearance: "no", // yes/no
      item_category: data.metafields.item_category, // product top category, similar to the available 'Featured Categories', excluding 'Major Appliances'
      item_category2: data.metafields.item_category2, // sub category as in menu (see Figma)
      item_category3: "", // sub category as in menu (see Figma)
      item_category4: "", // sub cateogry as in menu (see Figma)
      item_category5: "", // for stove - induction/electric/gas, for laundry - electric/gas, for cooktops - 'electric/gas', for tv - the resolution -> 4k, LED, UHD etc
      item_category6: "", // for TVs, the TV size in inches, for cooktops - the element numbers
      item_variant: data.metafields.condition, // product condition - new/open box, scratch/dent, like new/refurbished
      quantity: 1, // insert product added
    },
  ];
  if (warrantyData) {
    items.push({
      item_name: warrantyData.title, // shopify product name
      item_id: data.productData.productId, // shopify product id
      color: "",
      price: Number(warrantyData.price),
      item_price_range: "",
      item_coupon: "", // "48%", discount percentage
      item_width: "", // item width in inches
      item_depth: "",
      item_brand: "",
      item_on_clearance: "no", // yes/no
      item_category: "addon", // product top category, similar to the available 'Featured Categories', excluding 'Major Appliances'
      item_category2: "", // sub category as in menu (see Figma)
      item_category3: "", // sub category as in menu (see Figma)
      item_category4: "", // sub cateogry as in menu (see Figma)
      item_category5: "", // for stove - induction/electric/gas, for laundry - electric/gas, for cooktops - 'electric/gas', for tv - the resolution -> 4k, LED, UHD etc
      item_category6: "", // for TVs, the TV size in inches, for cooktops - the element numbers
      item_variant: "", // product condition - new/open box, scratch/dent, like new/refurbished
      quantity: 1, // insert product added
    });
  }

  window.dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      items: items,
    },
  });
}
let Loadcounter = 0;
subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  const dataElement = document
    .querySelector(`#shopify-section-${event.data.sectionId}`)
    ?.querySelector("#gtm-product-data");
  if (dataElement && dataElement.textContent) {
    try {
      const parsedData = JSON.parse(dataElement.textContent);
      viemItemsEvent(parsedData);
    } catch (error) {
      console.error("Error parsing GTM product data:", error);
    }
  }
});

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  const dataElement = document
    .querySelector(`#${event.sectionId}`)
    ?.querySelector("#gtm-product-data");

  if (dataElement && dataElement.textContent) {
    try {
      const parsedData = JSON.parse(dataElement.textContent);
      const jsonData = event.formData;
      let warrantyData = null;
      if (jsonData) {
        console.log("jsonData: ", jsonData);
        Object.keys(jsonData).forEach((key) => {
          if (key.includes("_for_product")) {
            const selectedWarranty = document.querySelector(
              ".add-warranty-to-cart.warranty-btn.selected",
            );
            if (selectedWarranty) {
              warrantyData = {
                title: selectedWarranty.dataset.name,
                variantId: selectedWarranty.dataset.variantId,
                price: selectedWarranty.dataset.variantPrice,
                productId: selectedWarranty.dataset.productId,
              };
            }
          }
        });
      }
      atcEvent(parsedData, warrantyData);
    } catch (error) {
      console.error("Error parsing GTM product data:", error);
    }
  } else {
    console.log("GTM product data not found, skipping analytics");
  }
});
